const CAPI_ENDPOINT = "/api/meta-capi";

// Set localStorage.setItem('dd_dev', '1') in your browser console to disable tracking.
// Remove with localStorage.removeItem('dd_dev') to re-enable.
function isDevMode() {
  try { return !!localStorage.getItem("dd_dev"); } catch { return false; }
}

function generateEventId() {
  return `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

export function trackEvent(eventName, customData = {}) {
  if (isDevMode()) return;
  const eventId = generateEventId();

  // 1. Fire browser Pixel event with event_id for dedup
  if (typeof window.fbq === "function") {
    window.fbq("track", eventName, customData, { eventID: eventId });
  }

  // 2. Fire Google Analytics event
  if (typeof window.gtag === "function") {
    const gaParams = { ...customData, event_id: eventId };
    if (customData.content_name) gaParams.item_name = customData.content_name;
    if (customData.value) gaParams.value = customData.value;
    if (customData.currency) gaParams.currency = customData.currency;
    window.gtag("event", eventName, gaParams);
  }

  // 3. Fire Microsoft Clarity custom event + tag all dimensions
  if (typeof window.clarity === "function") {
    window.clarity("event", eventName);
    // Forward every customData key as a Clarity tag (filterable in session recordings)
    Object.entries(customData).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        window.clarity("set", key, String(val));
      }
    });
  }

  // 4. Send server-side via CAPI
  const payload = {
    event_name: eventName,
    event_id: eventId,
    event_source_url: window.location.href,
    custom_data: Object.keys(customData).length > 0 ? customData : undefined,
  };

  fetch(CAPI_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {
    // Silent fail — pixel still fires client-side
  });
}

/**
 * Track ViewContent when a section scrolls into view.
 */
export function trackViewContent(contentName) {
  trackEvent("ViewContent", { content_name: contentName });
}
